import initData from 'init-data';

const defaultState = {
    ...initData
};

export default (state = defaultState) => {
    return state;
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/reducers/init-data.js